function o(i, t, r) {
  return t === void 0 && r === void 0 ? i : t !== void 0 && r === void 0 ? Math.max(i, t) : Math.min(t === void 0 && r !== void 0 ? i : Math.max(i, t), r);
}
export {
  o as c
};
